import { HelpIcon } from '@blocksuite/icons/rc';

import * as styles from './styles.css';

export const SEARCH_SYNTAX_PATH = '/help/search-syntax';

export function SearchQueryHelp({ iconOnly = false }: { iconOnly?: boolean }) {
  const basePath = environment.subPath.replace(/\/$/, '');

  return (
    <a
      className={iconOnly ? styles.iconLink : styles.link}
      href={`${basePath}${SEARCH_SYNTAX_PATH}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Search syntax (opens in a new tab)"
      title="Search syntax"
    >
      {iconOnly ? (
        <HelpIcon width={16} height={16} aria-hidden />
      ) : (
        'Search syntax'
      )}
    </a>
  );
}
